import axios, {
  AxiosError,
  InternalAxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { getAccessToken } from './token.service';
import { logFirebaseEvent } from './firebase.service';
import { msalInstance } from '..';

export interface AxiosRequestConfigWithMetadata
  extends InternalAxiosRequestConfig {
  metadata?: {
    startTime: number;
  };
  functionName?: string;
}

export const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export const interceptor = () => {
  const userId =
    msalInstance.getAllAccounts()[0]?.idTokenClaims?.oid || 'unknown';

  api.interceptors.request.use(
    async (config: AxiosRequestConfigWithMetadata) => {
      const accessToken = await getAccessToken();

      if (accessToken && config.headers) {
        if (typeof config.headers.set === 'function') {
          config.headers.set(
            'Authorization',
            `Bearer ${accessToken}`
          );
        } else {
          config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
      }

      config.metadata = { startTime: performance.now() };
      return config;
    },
    (error: AxiosError) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response: AxiosResponse) => {
      const config =
        response.config as AxiosRequestConfigWithMetadata;
      const duration =
        performance.now() - (config?.metadata?.startTime || 0);
      const functionName = config.functionName;

      console.log(functionName)

      if (functionName) {
        try {
          logFirebaseEvent(`ok_${functionName}`, {
            message: response.statusText,
            status: response.status,
            url: config?.url,
            method: config?.method,
            duration,
            route:
              window.location.pathname
                .toLowerCase()
                .replace(/[^a-zA-Z0-9]/g, '_') === '_'
                ? 'home'
                : window.location.pathname
                    .toLowerCase()
                    .replace(/[^a-zA-Z0-9]/g, '_')
                    .replace(/^_/, ''),
            data: JSON.stringify(response?.data),
            params: JSON.stringify(config?.params),
            statusText: response.statusText,
            response: JSON.stringify(response.data),
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            userId,
          });
        } catch (firebaseError) {
          console.error(
            'Error logging event to Firebase:',
            firebaseError
          );
        }
      }

      return response;
    },
    async (error: AxiosError) => {
      const config = error.config as AxiosRequestConfigWithMetadata;
      const duration =
        performance.now() - (config?.metadata?.startTime || 0);
      const functionName = config.functionName;

      if (functionName) {
        try {
          logFirebaseEvent(`not_ok_${functionName}`, {
            message: error.message,
            status: error.response?.status,
            url: config?.url,
            method: config?.method,
            duration,
            route:
              window.location.pathname
                .toLowerCase()
                .replace(/[^a-zA-Z0-9]/g, '_') === '_'
                ? 'home'
                : window.location.pathname
                    .toLowerCase()
                    .replace(/[^a-zA-Z0-9]/g, '_')
                    .replace(/^_/, ''),
            data: JSON.stringify(config?.data),
            params: JSON.stringify(config?.params),
            statusText: error.response?.statusText,
            response: JSON.stringify(error.response?.data),
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            userId,
          });
        } catch (firebaseError) {
          console.error(
            'Error logging event to Firebase:',
            firebaseError
          );
        }
      }

      return Promise.reject(error);
    }
  );
};
